import type {DefectStatus} from './_models'

export function canOfficeReviewDefect(options: {
  status?: DefectStatus | null
  isCrew: boolean
  hasPermission: boolean
  officeReviewedAt?: string | null
}): boolean {
  return options.status === 'CLOSE' && !options.officeReviewedAt && !options.isCrew && options.hasPermission
}
